import { checkDefined } from 'faro-common-model';
export function toDynamicFieldResolution(resolution) {
    checkDefined(resolution.id, 'DynamicFieldResolution', 'id');
    checkDefined(resolution.name, 'DynamicFieldResolution', 'name');
    checkDefined(resolution.status, 'DynamicFieldResolution', 'status');
    return {
        id: resolution.id,
        name: resolution.name,
        text: resolution.text || '',
        status: resolution.status,
    };
}
//# sourceMappingURL=dynamic-field-resolution.js.map